import React from 'react'

interface SplitIconProps {
  size?: number | string
  color?: string
  className?: string
}

const SplitIcon: React.FC<SplitIconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 752 752"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g transform="translate(0,752) scale(0.1,-0.1)" fill={color} stroke="none">
      <path
        d="M4865 6117 c-67 -23 -101 -44 -143 -92 -67 -76 -72 -104 -72 -387 l0
-248 -604 0 c-363 0 -624 -4 -656 -10 -168 -32 -308 -168 -453 -440 -25 -47
-103 -211 -172 -364 -141 -312 -172 -376 -221 -458 l-35 -57 -442 -3 -442 -3
-55 -26 c-114 -54 -174 -146 -174 -269 0 -123 60 -215 174 -269 l55 -26 443
-3 442 -3 43 -74 c42 -72 70 -129 274 -576 127 -276 206 -409 306 -516 87 -91
160 -135 256 -153 32 -6 295 -10 657 -10 l604 0 0 -248 c0 -286 5 -312 76
-391 59 -66 127 -95 219 -95 85 0 132 20 230 94 138 106 831 687 863 723 91
106 113 230 58 340 -18 38 -54 83 -100 127 -91 89 -793 669 -869 721 -70 46
-112 59 -193 59 -107 0 -202 -60 -257 -164 -21 -38 -22 -57 -27 -306 l-5 -265
-552 -3 -553 -2 -24 38 c-39 62 -128 243 -226 462 -103 230 -186 398 -237 483
l-34 57 34 58 c51 84 134 252 237 482 98 219 187 400 226 462 l24 38 553 -2
552 -3 5 -265 c5 -249 6 -268 27 -306 56 -104 150 -164 258 -164 132 0 142 7
705 477 407 340 447 380 476 481 28 95 -1 199 -78 289 -32 36 -725 617 -863
723 -38 29 -89 61 -112 72 -55 24 -148 31 -198 15z"
      />
    </g>
  </svg>
)

export default SplitIcon
